import { createFileRoute } from '@tanstack/react-router'
import { ReportDetail } from '@/features/reports/detail'
import { reportDetailSearchSchema } from '@/features/reports/navigation'

export const Route = createFileRoute('/_authenticated/reports/$runId')({
  validateSearch: reportDetailSearchSchema,
  component: ReportDetail,
})
